import { ReactNode } from 'react';

interface CvFooterProps {
  children?: ReactNode;
}

export default function CvFooter({ children }: CvFooterProps) {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-12 text-center text-white/60 text-sm print:mt-4 print:text-black print:bg-white print:border-0">
      <div className="border-t border-[rgba(255,136,255,0.15)] pt-4 print:border-gray-300 print:bg-white print:pt-2">
        {children || (
          <p className="print:bg-white print:mb-0">© {currentYear} Robin Wichmann</p>
        )}
      </div>
      <div className="hidden print:block print:h-8 print:bg-white"></div>
    </footer>
  );
} 